export default "__VITE_ASSET__B_v228E7__"